/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  TrackingEventInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient';
import type { ErrorType } from '../../../internalAxiosClient';




/**
 * @summary Create Tracking Event
 */
export const createTrackingEvent = (
    trackingEventInput: MaybeRef<TrackingEventInput>,
 signal?: AbortSignal
) => {
      trackingEventInput = unref(trackingEventInput);
      
      return axiosClient<void>(
      {url: `/tracking_events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trackingEventInput, signal
    },
      );
    }
  


export const getCreateTrackingEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,{data: TrackingEventInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,{data: TrackingEventInput}, TContext> => {
    
const mutationKey = ['createTrackingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrackingEvent>>, {data: TrackingEventInput}> = (props) => {
          const {data} = props ?? {};

          return  createTrackingEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTrackingEventMutationResult = NonNullable<Awaited<ReturnType<typeof createTrackingEvent>>>
    export type CreateTrackingEventMutationBody = TrackingEventInput
    export type CreateTrackingEventMutationError = ErrorType<unknown>

    /**
 * @summary Create Tracking Event
 */
export const useCreateTrackingEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrackingEvent>>, TError,{data: TrackingEventInput}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createTrackingEvent>>,
        TError,
        {data: TrackingEventInput},
        TContext
      > => {

      const mutationOptions = getCreateTrackingEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    